<template>
	<div>
		<v-footer dark class="rojo">
			<v-row class="d-flex d-sm-none">
				<!-- <v-col>
				<v-img
					alt="Instituto de los Mexicanos en el Exterior"
					class=""
					contain
					height="45"
					:src="`${logoIme}`"
					:lazy-src="`${logoIme}`" />
			</v-col> -->
				<v-col cols class="white--text text-center pt-5 pb-5">
					{{ new Date().getFullYear() }} — SRE,
					<strong>IMME</strong>
				</v-col>
			</v-row>

			<v-row class="d-none d-sm-flex">
				<v-col cols class="white--text text-center mb-5 small">
					{{ new Date().getFullYear() }} — Secretaría de Relaciones Exteriores,
					<strong>Instituto de Mexicanas y Mexicanos en el Exterior</strong>
				</v-col>
			</v-row>
		</v-footer>
		<div class="footer-pleca">&nbsp;</div>
	</div>
</template>
<script>
	import logo from "@/assets/images/logos/gobmx-sre.svg";
	export default {
		name: "FooterTemplate",

		data: () => ({
			logoIme: logo,
			icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
		}),
	};
</script>
